import { HTMLAttributes, MouseEventHandler } from 'react';
import { StepperStatus } from '../../enums';
import { StepDisplay } from './StepDisplay';
import styles from './styles.module.scss';

export type StepProps = HTMLAttributes<HTMLLIElement> & {
  label: string;
  stepNumber: number;
  link?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  status?: StepperStatus;
};

export const Step = ({
  label,
  stepNumber,
  link = '',
  onClick,
  status = StepperStatus.Default,
}: StepProps) => (
  <li key={`${stepNumber}-${label}`} className={`${styles.stepperItem} ${styles[status]}`}>
    {status === StepperStatus.Completed ? (
      link ? (
        <a href={link}>
          <StepDisplay label={label} status={status} stepNumber={stepNumber} />
        </a>
      ) : (
        <button onClick={onClick}>
          <StepDisplay label={label} status={status} stepNumber={stepNumber} />
        </button>
      )
    ) : (
      <StepDisplay label={label} status={status} stepNumber={stepNumber} />
    )}
  </li>
);
